import {isNotNil} from 'ramda-adjunct';

// number 0.7999 should be displayed as 79%
export const decimalToPercentRank = (num?: number) =>
  isNotNil(num) ? `${Math.floor(num * 100)}%` : 'N/A';
